import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  Grid, Paper, Tabs, Tab,
} from '@mui/material';
import { List, MapOutlined } from '@mui/icons-material';

import { RunTable } from './run-table';
import { RunScheduleTable } from './run-schedule-table';

const RUNS_TAB = 'Runs';
const SCHEDULE_TAB = 'Schedules';

const styles = {
  root: {
    width: '95%',
    margin: '0 auto',
    marginTop: 10,
  },
  tabs: {
    flexGrow: 1,
    width: '95%',
    margin: '0 auto',
    borderRadius: 0,
    borderBottom: 'solid lightgray 1px',
  },
  section: {
    width: '100%',
    margin: '0 auto',
    overflowX: 'auto',
  },
  labelIcon: {
    width: 'auto',
    paddingRight: 0,
  },
  iconLabelWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  indicator: {
    backgroundColor: 'info.dark',
  },
  selected: {
    color: 'info.dark',
  },
};

class MarketRunTables extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabValue: 0,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, value) {
    this.setState({ tabValue: value });
  }

  render() {
    const { tabValue } = this.state;
    return (
      <Grid>
        <Grid
          container
          justifyContent="flex-start"
        >
          <Grid
            item
            xs={12}
            style={styles.root}
          >
            <Grid
              container
              alignItems="center"
              direction="row"
            >
              <Grid
                item
                style={styles.section}
              >
                <Paper style={styles.tabs}>
                  <Tabs
                    value={tabValue}
                    indicatorColor="primary"
                    textColor="primary"
                    classes={{ indicator: styles.indicator }}
                    onChange={this.handleChange}
                  >
                    <Tab
                      disableRipple
                      disableFocusRipple
                      label={RUNS_TAB}
                      iconPosition="start"
                      icon={<List classes={{ root: styles.labelIcon }} />}
                      classes={{
                        wrapper: styles.iconLabelWrapper,
                        selected: styles.selected,
                      }}
                    />
                    <Tab
                      disableRipple
                      disableFocusRipple
                      label={SCHEDULE_TAB}
                      iconPosition="start"
                      icon={<MapOutlined classes={{ root: styles.labelIcon }} />}
                      classes={{
                        wrapper: styles.iconLabelWrapper,
                        selected: styles.selected,
                      }}
                    />
                  </Tabs>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {tabValue === 0 && <RunTable />}
        {tabValue === 1 && <RunScheduleTable />}
      </Grid>
    );
  }
}

export default withRouter(MarketRunTables);
